import React from 'react'
import { SnackbarProvider, closeSnackbar } from 'notistack'

interface NotificationProviderProps {
  children: React.ReactNode
  maxSnack?: number
  autoHideDuration?: number
  anchorOrigin?: {
    vertical: 'top' | 'bottom'
    horizontal: 'left' | 'center' | 'right'
  }
}

export const NotificationProvider: React.FC<NotificationProviderProps> = ({
  children,
  maxSnack = 3,
  autoHideDuration = 3000,
  anchorOrigin = {
    vertical: 'top',
    horizontal: 'right',
  },
}) => {
  return (
    <SnackbarProvider
      maxSnack={maxSnack}
      anchorOrigin={anchorOrigin}
      autoHideDuration={autoHideDuration}
      action={(snackbarId) => (
        <button
          onClick={() => closeSnackbar(snackbarId)}
          className='notistack-close-button'
          style={{
            background: 'none',
            border: 'none',
            color: 'inherit',
            cursor: 'pointer',
            fontSize: '18px',
            padding: '0',
            marginRight: '8px',
          }}
          aria-label='Close notification'
        >
          ✕
        </button>
      )}
    >
      {children}
    </SnackbarProvider>
  )
}

export default NotificationProvider
